import { render, staticRenderFns } from "./ThreadMenu.vue?vue&type=template&id=e40d5002&"
import script from "./ThreadMenu.vue?vue&type=script&lang=js&"
export * from "./ThreadMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports